import { CreateAppContextApi } from './types'
import React, { useContext } from 'react'

export const createAppContextApi: CreateAppContextApi = <Ctx>() => {
    // @ts-ignore
    const nullContext = null as Ctx

    const Context = React.createContext<Ctx>(nullContext)

    return {
        AppContextProvider: Context.Provider,
        getAppContext: () => useContext(Context)
    }
}
